module.exports = __webpack_public_path__ + "static/media/hero-image-mobile@4x.991f8116.jpg";